import { render, staticRenderFns } from "./ProductSpecimenSave.vue?vue&type=template&id=504cb472"
import script from "./ProductSpecimenSave.vue?vue&type=script&lang=js"
export * from "./ProductSpecimenSave.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecimenSave.vue?vue&type=style&index=0&id=504cb472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports